import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const LiveTrip = React.lazy(() => import('./Vendordashboard/index'));
const CorporateAdmin = React.lazy(() => import('./Vendordashboard/index_copy'));

export const LiveTripConfig = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/livetrip',
    element: <LiveTrip />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/copy',
    element: <CorporateAdmin />,
  },
];
